import gql from 'graphql-tag'

const allZone = gql`
  query allZone {
    allZone {
      nome
    }
  }
`

export default allZone



// WEBPACK FOOTER //
// ./src/graphql/queries/zone.js